"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotifyClient = useNotifyClient;
const NotifyClient_1 = require("@juvare/platform-sdk-js/NotifyClient");
const react_1 = __importDefault(require("react"));
function useNotifyClient(baseUrl, tokenProvider) {
    return react_1.default.useMemo(() => new NotifyClient_1.NotifyClient(baseUrl, tokenProvider), [baseUrl, tokenProvider]);
}
